import api from "@/libs/axios";
import { SearchResponse } from "@/pages/taskpane/lib/api/types/AxiosMethod";
import { apiEnum } from "@/pages/taskpane/shared/types/enums/apiEnum";
import { AxiosError } from "axios";
import { IGetResourceCalendarRequest, ResourceCalendarInfo } from "./types/resourceCalendarEntity";

export const getResourceCalendarBoldDate = async (
  request: IGetResourceCalendarRequest
): Promise<SearchResponse<string>> => {
  try {
    const response = await api.post(apiEnum.getResourceCalendarBoldDate, request);
    return new SearchResponse(response, undefined, "data");
  } catch (error) {
    return new SearchResponse((error as AxiosError).response);
  }
};

export const getResourceCalendarSchedule = async (request: IGetResourceCalendarRequest): Promise<SearchResponse<ResourceCalendarInfo>> => {
  try {
    const response = await api.post(apiEnum.getResourceCalendarSchedule, request);
    return new SearchResponse(response, ResourceCalendarInfo, "data");
  } catch (error) {
    return new SearchResponse((error as AxiosError).response);
  }
};
